import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { Service, UpdateServiceBulkRequest } from '@shared/service/models';
import { ApiClientService } from '@tablesready/api-client';

@Injectable({providedIn: 'root'})
export class ServiceApiService {
  private readonly basePath = '/v.1/services';

  constructor(
    private readonly http: ApiClientService,
  ) { }

  getById(id: string): Observable<Service> {
    return this.http.get<Service>(`${this.basePath}/${id}`);
  }

  getAll(): Observable<Service[]> {
    return this.http.get<Service[]>(this.basePath);
  }

  create(data: Omit<Service, '_id'>): Observable<Service> {
    return this.http.post<Service>(this.basePath, data);
  }

  deleteById(id: string): Observable<void> {
    return this.http.delete<void>(`${this.basePath}/${id}`);
  }

  updateById(id: string, data: Partial<Omit<Service, '_id'>>): Observable<Service> {
    return this.http.put<Service>(`${this.basePath}/${id}`, data);
  }

  updateBatch(data: UpdateServiceBulkRequest[]): Observable<void> {
    return this.http.put<void>(this.basePath, data);
  }
}
